import { registerObservabilityReporter } from './observability';
import { localReporter } from './reporters/local-reporter';
import { consoleReporter } from './reporters/console-reporter';

let initialized = false;

/**
 * Call once at app bootstrap (`main.tsx`). Registers the local reporter
 * unconditionally -- it's the only durable sink this pipeline has today --
 * plus the console reporter in dev only, so events stay visible while
 * developing without adding console noise to a production reader's device.
 */
export function initObservability(): void {
	if (initialized) {
		return;
	}
	initialized = true;

	registerObservabilityReporter(localReporter);

	if (import.meta.env.DEV) {
		registerObservabilityReporter(consoleReporter);
	}
}
